import { createContext } from 'react';

type Props = {
  changeLang: any,
  getLang: any,
  dialog: any,
  openDialog: any,
  closeDialog: any
};

const context = createContext<Partial<Props>>({});

export default context;
